import {Injectable} from '@angular/core';

export const CABECERA_SESION_EDICION = 'X-Sesion-Edicion';

/**
 * Identidad de esta pestaña para el bloqueo de edición. La misma cuenta se usa en varios equipos
 * a la vez, así que el dueño de un bloqueo no puede ser el usuario: es la sesión.
 *
 * Vive solo en memoria a propósito. Nada de localStorage ni sessionStorage: duplicar una pestaña
 * copia el sessionStorage y dos pestañas compartirían identidad. Un F5 estrena sesión; la
 * anterior se libera al descargar la página o caduca sola.
 */
@Injectable({providedIn: 'root'})
export class SesionEdicionService {
    public readonly id: string = SesionEdicionService._uuid();

    private static _uuid(): string {
        if (typeof crypto !== 'undefined' && typeof (crypto as any).randomUUID === 'function') {
            return (crypto as any).randomUUID();
        }
        // randomUUID solo existe en contexto seguro (https/localhost)
        const b = crypto.getRandomValues(new Uint8Array(16));
        b[6] = (b[6] & 0x0f) | 0x40;
        b[8] = (b[8] & 0x3f) | 0x80;
        const h = Array.from(b, x => x.toString(16).padStart(2, '0')).join('');
        return `${h.slice(0, 8)}-${h.slice(8, 12)}-${h.slice(12, 16)}-${h.slice(16, 20)}-${h.slice(20)}`;
    }
}
